<template>
    <div>
        <div ref="containt">
            <v-row justify="center">
                <v-dialog
                    v-model="dialog"
                    fullscreen
                    hide-overlay
                    transition="dialog-bottom-transition"
                >
                    <v-card>
                        <v-toolbar dark color="primary" class="d-print-none">
                            <v-btn icon dark @click="close()">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                            <v-toolbar-title></v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-toolbar-items>
                                <v-btn dark text @click="print()"
                                    >Click Gen Barcode</v-btn
                                >
                            </v-toolbar-items>
                        </v-toolbar>

                        <v-list class="d-print-none" three-line subheader>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        <b
                                            >LIST ALL PART BARCODE - PART NAME :
                                            {{ part.part_name }}</b
                                        >
                                    </v-list-item-title>
                                    <!-- <v-list-item-subtitle></v-list-item-subtitle> -->
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                        <template>
                            <v-card flat class="">
                                <v-card-text>
                                    <v-container fluid>
                                        <v-row>
                                            <v-col
                                                cols="12"
                                                sm="5"
                                                class="d-print-none"
                                            >
                                                <v-simple-table>
                                                    <template v-slot:default>
                                                        <thead>
                                                            <tr>
                                                                <th
                                                                    class="text-center"
                                                                >
                                                                    Single Part
                                                                </th>
                                                                <th
                                                                    class="text-center"
                                                                >
                                                                    Serial
                                                                </th>
                                                                <th
                                                                    class="text-center"
                                                                >
                                                                    Date
                                                                </th>
                                                                <th>
                                                                    <v-btn
                                                                        small
                                                                        :color="
                                                                            colorx
                                                                        "
                                                                        @click="
                                                                            all()
                                                                        "
                                                                        >All
                                                                        Part</v-btn
                                                                    >
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr
                                                                v-for="item in part.onhand"
                                                                :key="
                                                                    item.singlepart
                                                                "
                                                            >
                                                                <td
                                                                    class="text-center"
                                                                >
                                                                    {{
                                                                        item.singlepart
                                                                    }}
                                                                </td>
                                                                <td
                                                                    class="text-center"
                                                                >
                                                                    {{
                                                                        item.serial
                                                                    }}
                                                                </td>
                                                                <td
                                                                    class="text-center"
                                                                >
                                                                    {{
                                                                        item.created_at
                                                                    }}
                                                                </td>
                                                                <td>
                                                                    <v-checkbox
                                                                        v-model="
                                                                            checkbox
                                                                        "
                                                                        label=""
                                                                        :value="
                                                                            item
                                                                        "
                                                                        color="green"
                                                                        class="pad-0 mar-1"
                                                                    ></v-checkbox>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </template>
                                                </v-simple-table>
                                            </v-col>
                                            <v-col
                                                cols="12"
                                                sm="7"
                                                id="printMe"
                                            >
                                                <div class="mar-2">
                                                    <v-row>
                                                        <table
                                                            width="350"
                                                            border="0"
                                                            cellspacing="0"
                                                            cellpadding="0"
                                                            style="border-width: 1px;  border-left-style: dashed; border-bottom-style:dashed; border-right-style:dashed; border-top-style:dashed;"
                                                            v-for="data_barcode in checkbox"
                                                            :key="
                                                                data_barcode.singlepart
                                                            "
                                                        >
                                                            <tr>
                                                                <td>
                                                                    <table
                                                                        width="100%"
                                                                        border="0"
                                                                        cellspacing="0"
                                                                        cellpadding="0"
                                                                    >
                                                                        <tr
                                                                            class="mar-3"
                                                                        >
                                                                            <td
                                                                                width="36%"
                                                                                align="center"
                                                                            >
                                                                                <v-img
                                                                                    src="http://118.172.229.205:9000/images/project/acacia.jpg"
                                                                                    class="img-1"
                                                                                ></v-img>
                                                                            </td>
                                                                            <td
                                                                                width="60%"
                                                                                align="left"
                                                                            >
                                                                                {{
                                                                                    part.project_name
                                                                                }}
                                                                            </td>
                                                                            <td
                                                                                width="4%"
                                                                            >
                                                                                &nbsp;
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td
                                                                                align="center"
                                                                            >
                                                                                Single
                                                                                Part
                                                                                :
                                                                            </td>
                                                                            <td
                                                                                width="48%"
                                                                                align="center"
                                                                            >
                                                                                <barcode
                                                                                    v-bind:value="
                                                                                        data_barcode.singlepart
                                                                                    "
                                                                                    class="bar-1"
                                                                                >
                                                                                </barcode>
                                                                            </td>
                                                                            <td
                                                                                width="48%"
                                                                            >
                                                                                <template>
                                                                                    <div
                                                                                        id="app"
                                                                                    >
                                                                                        <qrcode
                                                                                            :background="
                                                                                                background
                                                                                            "
                                                                                            :size="
                                                                                                size
                                                                                            "
                                                                                            :cls="
                                                                                                qrCls
                                                                                            "
                                                                                            :value="
                                                                                                data_barcode.singlepart
                                                                                            "
                                                                                        ></qrcode>
                                                                                    </div>
                                                                                </template>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td
                                                                                colspan="3"
                                                                                height="2"
                                                                            ></td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td
                                                                                align="center"
                                                                            >
                                                                                Serial
                                                                                Part
                                                                                :
                                                                            </td>
                                                                            <td
                                                                                width="60%"
                                                                                align="center"
                                                                            >
                                                                                <barcode
                                                                                    v-bind:value="
                                                                                        data_barcode.serial
                                                                                    "
                                                                                    class="bar-1"
                                                                                >
                                                                                </barcode>
                                                                            </td>
                                                                            <td>
                                                                                <template>
                                                                                    <div
                                                                                        id="app"
                                                                                    >
                                                                                        <qrcode
                                                                                            :background="
                                                                                                background
                                                                                            "
                                                                                            :size="
                                                                                                size
                                                                                            "
                                                                                            :cls="
                                                                                                qrCls
                                                                                            "
                                                                                            :value="
                                                                                                data_barcode.serial
                                                                                            "
                                                                                        ></qrcode>
                                                                                    </div>
                                                                                </template>
                                                                            </td>
                                                                        </tr>
                                                                    </table>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </v-row>
                                                </div>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>
                            </v-card>
                        </template>
                    </v-card>
                </v-dialog>
            </v-row>
        </div>
    </div>
</template>

<script>
const url = `${process.env.VUE_APP_ROOT_API}/api/getbarcode/`

import axios from "axios"
import VueBarcode from "vue-barcode"
import Qrcode from "v-qrcode/src/index"

export default {
    mounted() {
        // console.log("--redy")
    },
    components: {
        barcode: VueBarcode,
        Qrcode,
    },
    props: ["dialog", "part"],
    methods: {
        close() {
            this.checkbox = []
            this.chk = false
            this.$emit("page_barcode")
        },
        all() {
            if (this.chk === true) {
                this.chk = false
                this.colorx = "primary"
                this.checkbox = []
            } else {
                this.chk = true
                this.colorx = "success"
                this.checkbox = this.part.onhand
            }
        },
        print() {
            window.print()
        },
    },
    data() {
        return {
            checkbox: [],
            qrCls: "qrcode",
            size: 47,
            background: "#FFFF",
            chk: false,
            colorx: "primary",
            output: null,
        }
    },
}
</script>
<style scoped>
th {
    font-size: 16px !important;
}
.pad-0 {
    padding: -10px !important;
}
.mar-1 {
    margin-left: 30px;
}
.mar-2 {
    margin-top: -4px !important;
}
.mar-3 {
    margin-top: 20px !important;
}
.vue-barcode-element {
    width: 35%;
    height: 55px;
}
.img-1 {
    width: 40% !important;
}
.aa {
    padding: 1000px !important;
}
</style>
